//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "EORTC",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
        item6: '',
      },
      item1List: [
        { value: '0', name: '单发' },
        { value: '3', name: '2-7' },
        { value: '6', name: '≥8' },
      ],
      item2List: [
        { value: '0', name: '≤3cm' },
        { value: '3', name: '>3cm' },
      ],
      item3List: [
        { value: '0', name: '原发' },
        { value: '2', name: '≤1次/年' },
        { value: '4', name: '>1次/年' },
      ],
      item4List: [
        { value: '0', name: 'Ta' },
        { value: '1', name: 'T1' },
      ],
      item5List: [
        { value: '0', name: '无' },
        { value: '1', name: '有' },
      ],
      item6List: [
        { value: '0', name: 'G1' },
        { value: '1', name: 'G2' },
        { value: '2', name: 'G3' },
      ],
      num1: '',
      text1: '',
      num2: '',
      text2: '',
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let n1 = form.item1
        if (n1 == 6) {
          n1 = 3
        }
        let n3 = form.item3
        if (n3 == 4) {
          n3 = 2
        }
        let n4 = form.item4
        if (n4 == 1) {
          n4 = 4
        }
        let n5 = form.item5
        if (n5 == 1) {
          n5 = 6
        }
        let n6 = form.item6
        if (n6 == 1) {
          n6 = 0
        } else if (n6 == 2) {
          n6 = 5
        }
        self.num1 = form.item1 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6
        self.num2 = n1 + form.item2 + n3 + n4 + n5 + n6
        if (self.num1 == 0) {
          self.text1 = `低危：1年复发率(%)15(15~19)
          5年复发率(%)31(24~37)`
        } else if (self.num1 < 5) {
          self.text1 = `中危：1年复发率(%)24(21~26)
          5年复发率(%)46(42~49)`
        } else if (self.num1 < 10) {
          self.text1 = `中危：1年复发率(%)38(35~41)
          5年复发率(%)62(58~65)`
        } else {
          self.text1 = `高危：1年复发率(%)61(55~67)
          5年复发率(%)78(73~84)`
        }
        if (self.num2 == 0) {
          self.text2 = `低危：1年复发率(%)0.2(0.0~0.7)
          5年复发率(%)0.8(0~1.7)`
        } else if (self.num2 < 7) {
          self.text2 = `中危：1年复发率(%)1.0(0.4~1.6)
          5年复发率(%)6.0(5~8.0)`
        } else if (self.num2 < 14) {
          self.text2 = `中危：1年复发率(%)5.0(4.0~7.0)
          5年复发率(%)17(14~20)`
        } else {
          self.text2 = `高危：1年复发率(%)17.0(10~24)
          5年复发率(%)45(35~55)`
        }
        self.hasScore = true;
        return String(self.num1, self.num2);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/EORTC.vue